var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor flex-c"},[_c('img',{staticStyle:{"margin-left":"0.625rem"},attrs:{"src":require("../../../assets/icons/xiazai.png")}})])
}]

export { render, staticRenderFns }